import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from '#src/shared/routes';

import { Loading } from '#src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'admin-free-promotion',
		path: '/admin/p/:slug/create_free_promotion',
		component: loadable(async () => import(/* webpackChunkName: "pages/admin_freePromotion" */ './index'), {
			exportName: 'FreePromotion',
			fallback: Loading,
		}),
		restrictedAccess: {
			authOnly: true,
			role: ['staff', 'support'],
		},
		frame: true,
	},
];
